const equipmentsRegistrationLimitWarning = {
  limitPercentage: {
    'appBar': 'Límite de equipos al {{percentage}}%',
    'sideBar': '{{percentage}}% del límite de equipos',
    'table': '{{percentage}}% del límite de equipos',
  },
  registeredEquipments: 'Equipos registrados',
  contactAccountables: 'Enviar correo electrónico',
  reachedInfoPrefix: 'Has alcanzado',
  reachedInfoSuffix: "el límite de equipos de tu plan",
  reachedInfoText: 'mejora tu plan para continuar registrando',
  notificationSuccessTitle: 'Notificación enviada',
  notificationSuccessText: 'Los responsables han sido notificados con éxito.',
  notificationErrorTitle: 'Error al enviar la notificación',
  notificationErrorText: 'No se pudo enviar la notificación a los responsables. Por favor, inténtalo de nuevo.',
  upgradeInfo: 'para registrar más equipos, necesitarás mejorar tu plan. Haz clic en "Enviar correo electrónico" o envía un correo electrónico a los siguientes responsables GAP',
  noAccountables: 'No hay responsables',
  modalTitle: 'Límite de equipos',
  messageSentTitle: 'Mensaje enviado!',
  messageSentText: 'Uno de nuestros consultores se pondrá en contacto con usted en breve.',
};

export default equipmentsRegistrationLimitWarning;
